import { render, staticRenderFns } from "./PortineriaOspitiView.vue?vue&type=template&id=02a04502&"
import script from "./PortineriaOspitiView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaOspitiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports